var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},[_c('LeftNavigation'),_c('div',{staticClass:"vca-page"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }